<div class="main-box">
    <div class="left-sub-box">
        <div class="left-sub-container">
            <div *ngIf="hasPostHubAccess" class="post-nav-container">
                <div style="width: 20px; height: 20px; left: 0px;position: absolute">
                    <img src="assets/post-icon.svg">
                </div>
                <div class="left-item-text">Posts Hub</div>
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
            <div *ngIf="hasCompetitionZoneAccess" style="width: 172.92px; height: 19.03px; position: relative">
                <div style="width: 3%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid"></div>
                <div class="left-item-text"> Competitions Hub</div>
                <img src="assets/competition-icon.svg">
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
        </div>
    </div>

    <div class="right-sub-box">

        <div fxLayout="row">
            <div fxFlex="64">
                <div fxLayout="row">
                    <img src="assets/back-icon.svg" style="margin-right: 7px; cursor: pointer;"
                    routerLink="/admin/social-hub/competition-zone/{{ status }}">
                    <div
                        style="width: 559.87px; height: 29px;justify-content: space-between; align-items: flex-start; gap: 8px; display: inline-flex">
                        <div
                            style="color: #0E0E0E; font-size: 20px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word;">
                            Competition Details
                        </div>
                        <div *ngIf="status == 'OPEN' || status == 'CLOSED' || status == 'DRAFT'"
                            style="padding-left: 12px; padding-right: 12px; padding-top: 6px; padding-bottom: 6px; background: #FFE9E9; border-radius: 20px; justify-content: center; align-items: center; gap: 8px; display: flex"
                            [ngStyle]="{'background':status === 'CLOSED' ? '#FFE9E9' : 'rgba(0, 186.12, 52.11, 0.10)' }"
                            [ngStyle]="status === 'DRAFT' && {'background' : ''}">
                            <div *ngIf="status == 'OPEN'"
                                style="color: #00BA34; font-size: 12px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.20px; word-wrap: break-word">
                                Open
                            </div>
                            <div *ngIf="status == 'CLOSED'"
                                style="color: #EB5757; font-size: 12px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.20px; word-wrap: break-word">
                                Closed
                            </div>
                            <div *ngIf="status == 'DRAFT'" >
                                <img src="assets/three-dot.svg" style="cursor: pointer;" (click)="showEditField = !showEditField">                         
                                <div *ngIf="showEditField" style="width: 100%; height: 100%; position: relative">
                                    <div style="width: 102px; height: 77px; left: -105px; top: 0px; position: absolute; background: white; border: 1px #ECECEC solid">
                                        <div style="left: 0px; top: 0px; position: absolute; color: #0E0E0E; font-size: 13px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.20px; word-wrap: break-word; cursor: pointer;" 
                                        routerLink="/admin/social-hub/competition-zone/competition/create-competition/{{competitionId}}/edit">Edit</div>
                                        <div style="left: 0px; top: 47px; position: absolute; color: #0E0E0E; font-size: 13px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.20px; word-wrap: break-word">Delete</div>
                                        <div style="width: 80px; height: 0px; left: 0px; top: 32.02px; position: absolute; border: 1px #ECECEC solid"></div>
                                    </div>
                                    </div> 
                             </div>
                        </div>
                    </div>
                </div>
                <div class="name_section">
                    <div
                        style="text-align: center; color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                        Name</div>
                    <div
                        style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">
                        {{competitionDetails?.title?.en}}</div>
                </div>
                <div class="name_section" *ngIf="status == 'OPEN' || status=='CLOSED'">
                    <div
                        style="color: #0E0E0E; font-size: 16px; font-family: Montserrat; font-weight: 700; letter-spacing: 0.32px; word-wrap: break-word">
                        Total Entries received
                        <span
                            style="width: 100%; height: 100%; padding-left: 8px; padding-right: 8px; padding-top: 2px; padding-bottom: 2px; background: #F8B200; border-radius: 20px; gap: 8px;">{{competitionDetails?.submission_count}}</span>
                    </div>
                    <div style="width: 100%; height: 100%; border: 0.50px #C3D2FC solid"></div>

                    <div fxLayout="row">
                        <div class="alone-entry">
                            <span class="alone-entry-text">Approved</span>
                            <span class="alone-entry-number">{{approvedCompetition}}</span>
                        </div>
                        <div class="alone-entry">
                            <span class="alone-entry-text">Rejected</span>
                            <span class="alone-entry-number">{{rejectedCompetition}}</span>
                        </div>
                        <div class="alone-entry">
                            <span class="alone-entry-text">Shortlisted</span>
                            <span class="alone-entry-number">{{scheduleCompetition}}</span>
                        </div>
                        <div class="alone-entry">
                            <span class="alone-entry-text">Winners</span>
                            <span class="alone-entry-number">{{pendingCompetition}}</span>
                        </div>
                    </div>

                    <div style="width: 33%; height: 100%; padding-left: 20px; padding-right: 20px; padding-top: 7px; padding-bottom: 7px; background: #386AF6; border-radius: 80px; justify-content: center; align-items: center; gap: 10px; display: inline-flex; margin-left: auto; cursor: pointer;"
                        routerLink="/admin/social-hub/competition-zone/entry/{{status}}/{{competitionId}}/{{resultDeclared}}">
                        <div
                            style="align-self: stretch; justify-content: center; align-items: center; gap: 10px; display: flex">
                            <div
                                style="color: white; font-size: 12px; font-family: Montserrat; font-weight: 600; line-height: 30px; word-wrap: break-word">
                                View all Entries</div>
                            <img src="assets/left-open-angle.svg">
                        </div>
                    </div>

                </div>

                <div
                    style="flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 2px; display: inline-flex;margin-right: 42px;margin-bottom: 20px; margin-top: 17px;">
                    <div
                        style="text-align: center; color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                        Start Date</div>
                    <div
                        style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">
                        {{competitionDetails?.start_time | dateTransform: 'timestamp' }}</div>
                </div>
                <div
                    style="flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 2px; display: inline-flex">
                    <div
                        style="text-align: center; color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                        End Date</div>
                    <div
                        style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">
                        {{competitionDetails?.end_time | dateTransform: 'timestamp' }}</div>
                </div>
                <div fxLayout="row" style="gap: 100px;margin-bottom: 30px;">
                    <div fxLayout="column"> 
                        <span style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">Class</span>
                        <span style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">Class {{competitionDetails.grade.min_allowed_grade}} - {{competitionDetails.grade.max_allowed_grade}}</span>
                    </div>
                    <div fxLayout="column"> 
                        <span style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">Level</span>
                        <span  *ngIf="competitionDetails.state" style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">State Level</span>
                        <span *ngIf="!competitionDetails.state" style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">National Level</span>
                    </div>
                    <div fxLayout="column" *ngIf="competitionDetails.state"> 
                        <span style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">State</span>
                        <span style="text-align: center; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word">{{competitionDetails.state}}</span>
                    </div>
                </div>
                <div
                    style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                    Post text</div>
                <div
                    style="width: 100%; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word; margin-bottom: 20px;" [innerHTML]="competitionDetails?.details?.en">
                </div>
                <div
                    style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; word-wrap: break-word">
                    Instruction Details</div>
                <div style="width: 100%; color: #0E0E0E; font-size: 12px; font-family: Montserrat; font-weight: 500; line-height: 18.20px; word-wrap: break-word; margin-bottom: 17px;"
                    [innerHTML]="competitionDetails?.instructions?.en">
                </div>
                <div
                    style="width: 100%;padding: 8px; background: #EDF2FF; border-radius: 2.89px; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                    <div style="width: 516.81px; color: black; font-size: 12px; font-family: Montserrat; line-height: 15.98px; word-wrap: break-word"
                        [innerHTML]="competitionDetails?.note?.en">
                    </div>
                </div>
            </div>
            <div fxFlex="36" style="margin-left: 7px;">
                <div *ngIf="previewPage == 0">
                    <div
                        style="color: #0E0E0E; font-size: 14px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.28px; word-wrap: break-word; margin-bottom: 20px;">
                        Active Competition</div>
                    <div style="width: 100%;position: relative; margin-bottom: 54%;">
                        <div
                            style="width: 328px; height: 137px; left: 0px; top: 0px; position: absolute; background: #F4F6FA; box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.15); border-radius: 5px">
                        </div>
                        <div
                            style="width: 113px; height: 137px; left: -0px; top: 0px; position: absolute; background: linear-gradient(0deg, rgba(14, 14, 14, 0.20) 0%, rgba(14, 14, 14, 0.20) 100%)">
                            <img style="width: 113px;height: 136px;" [src]="competitionDetails?.photo">
                        </div>
                        <div style="width: 180px; height: 110px; left: 129.03px; top: 13.50px; position: absolute">
                            <div
                                style="width: 180px; height: 50px; left: 0px; top: 0px; position: absolute; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px; display: inline-flex">
                                <div
                                    style="width: 180px; color: #0E0E0E; font-size: 13px; font-family: Montserrat; font-weight: 700; line-height: 15.60px; word-wrap: break-word">
                                    {{competitionDetails?.title?.en}}</div>
                                <div
                                    style="color: #999999; font-size: 11px; font-family: Montserrat; font-weight: 500; line-height: 14.30px; word-wrap: break-word">
                                    Last Date- {{competitionDetails?.end_time | dateTransform: 'timestamp'}} </div>
                            </div>
                            <div style="width: 95.88px; height: 28px; left: 0px; top: 82px; position: absolute">
                                <div
                                    style="width: 95.88px; height: 28px; left: 0px; top: 0px; position: absolute; background: #386AF6; border-radius: 24px; border: 1px #386AF6 solid">
                                </div>
                                <div
                                    style="left: 17.04px; top: 3.25px; position: absolute; text-align: center; color: white; font-size: 11px; font-family: Montserrat; font-weight: 600; line-height: 21px; word-wrap: break-word">
                                    Send Entry</div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="width: 100%;justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                        <div style="width: 36px; height: 36px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                            (click)="onClickPreview(0)">
                            <div
                                style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                                1</div>
                        </div>
                        <div style="width: 36px; height: 36px; background: rgba(255, 255, 255, 0.80); border-radius: 4px; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                            (click)="onClickPreview(1)">
                            <div
                                style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                                2</div>
                        </div>
                    </div>
                </div>
                <div *ngIf="previewPage==1">
                    <div
                        style="width: 100%; background: #E1E9FE; margin-bottom: 20px; padding-bottom: 12px;padding-top: 12px;padding-left: 12px;">
                        <div
                            style="color: #0E0E0E; font-size: 20px; font-family: Montserrat; font-weight: 600; letter-spacing: 0.04px; word-wrap: break-word">
                            Preview</div>
                    </div>
                    <div class="smartphone">
                        <div class="content">
                            <div fxLayout="row">
                                <img src="assets/back-preview.svg">
                                <div
                                    style="color: #0E0E0E; font-size: 9.24px; font-family: Montserrat; font-weight: 700; line-height: 12.13px; word-wrap: break-word; margin-left: 3px;">
                                    {{competitionDetails?.title?.en}}</div>
                            </div>
                            <img style="width: 100%; height: 34%; margin-top: 10px;"
                                [src]="competitionDetails?.photo" />
                            <div
                                style="width: 100%; height: 5%; padding-left: 7.51px; padding-right: 7.51px; padding-top: 4.04px; padding-bottom: 4.04px; background: #FFE9E9; border-radius: 4.62px; overflow: hidden; flex-direction: column; justify-content: flex-start; align-items: center; gap: 5.78px; display: inline-flex">
                                <div
                                    style="width: 104px; text-align: center; color: #999999; font-size: 6.36px; font-family: Montserrat; font-weight: 500; line-height: 9.53px; word-wrap: break-word">
                                    Last Date- {{competitionDetails?.end_time | dateTransform: 'timestamp'}} </div>
                            </div>
                            <div
                                style="width: 100%;margin-top: 10px; color: black; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word" [innerHTML]="competitionDetails?.details?.en">
\                            </div>
                             <img style="width: 100%;height: 28%;" *ngIf="competitionDetails?.details_photo" [src]="competitionDetails.details_photo"  class="src">

                            <div style="width: 100%;margin-top: 10px; color: black; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word"
                                [innerHTML]="competitionDetails?.instructions?.en">
                            </div>
                            <div
                                style="width: 100%; margin-top: 10px; padding: 8px; background: #EDF2FF; border-radius: 2.89px; justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                                <div style="width: 516.81px; color: black; font-size: 6.93px; font-family: Montserrat; word-wrap: break-word"
                                    [innerHTML]="competitionDetails?.note?.en">
                                </div>
                            </div>
                            <div style="width: 100%; text-align: center"><span
                                    style="color: #999999; font-size: 6.93px; font-family: Montserrat; font-weight: 500; line-height: 9.01px; word-wrap: break-word">By
                                    clicking on Upload, I agree to the Competition Zone </span><span
                                    style="color: #386AF6; font-size: 6.93px; font-family: Montserrat; font-weight: 500; text-decoration: underline; line-height: 9.01px; word-wrap: break-word">Terms
                                    and Conditions</span></div>
                            <div
                                style="width: 100%; height: 6%; background: #386AF6; border-radius: 14.44px; padding-top: 6px;">
                                <div
                                    style="text-align: center; color: white; font-size: 9.24px; font-family: Montserrat; font-weight: 500; line-height: 12.71px; letter-spacing: 0.02px; word-wrap: break-word">
                                    Upload</div>
                            </div>
                        </div>
                    </div>
                    <div
                        style="width: 100%;justify-content: center; align-items: center; gap: 8px; display: inline-flex">
                        <div style="width: 36px; height: 36px; background: rgba(255, 255, 255, 0.80); border-radius: 4px; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                            (click)="onClickPreview(0)">
                            <div
                                style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                                1</div>
                        </div>
                        <div style="width: 36px; height: 36px; border-radius: 4px; border: 1px #386AF6 solid; justify-content: center; align-items: center; display: flex; cursor: pointer;"
                            (click)="onClickPreview(1)">
                            <div
                                style="text-align: center; color: #386AF6; font-size: 14px; font-family: Inter; font-weight: 600; word-wrap: break-word">
                                2</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>


</div>